import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ParticleService} from '@core/services/particle.service';
import {CommandService} from '@core/services/command.service';
import {ExpertServicesDynamicComponentHelper} from '@features/expert-services/expert-services-dynamic-component-helper';
import {RouterModule} from '@angular/router';
import {expertServicesRoutes} from '@features/expert-services/expert-services.routes';
import {PlatformCommand} from '@shared/commands/command-base';
import {PlatformToolExpertServicesHandler} from '@features/expert-services/services/platform-tool-expert-services-handler';
import {SharedModule} from '@shared/shared.module';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {ExpertServicesApiProvider} from '@features/expert-services/expert-services-api-provider';
import {CreateExpertWorkspaceCommandHandler} from '@features/expert-services/services/create-expert-workspace-command-handler';
import {CreateExpertServiceCommandHandler} from '@features/expert-services/services/create-expert-service-command-handler';
import { CreateExpertServicesDialogComponent } from './components/create-expert-services-dialog/create-expert-services-dialog.component';
import {CreateServiceTemplateCommandHandler} from '@features/expert-services/services/create-service-template-command-handler';
import {EditExpertServicesHyperlinkCellViewerComponent} from './components/cell-viewer/edit-hyperlink-cell-viewer/edit-expert-services-hyperlink-cell-viewer.component';
import {EditExpertServicesStringCellViewerComponent} from './components/cell-viewer/edit-expert-services-string-cell-viewer/edit-expert-services-string-cell-viewer.component';
import {PlatformToolCreateConsultantHandler} from '@features/expert-services/services/platform-tool-create-consultant-handler';
import {CreateConsultantDialogComponent} from '@features/expert-services/components/create-consultant-dialog/create-consultant-dialog.component';
import {ConsultantArchiveDialogComponent} from '@features/expert-services/components/consultant-case-archive-dialog/consultant-archive-dialog.component';
import { ExpertServiceCheckboxUpdateDialogComponent } from './components/expert-service-checkbox-update-dialog/expert-service-checkbox-update-dialog.component';
import {DialogDefinitionNavigationComponent} from '@features/expert-services/components/dialog-definition-editor/dialog-definition-navigation/dialog-definition-navigation.component';
import {MarketPlaceNavigationComponent} from '@features/expert-services/components/market-place-navigation/market-place-navigation.component';

@NgModule({
  declarations: [
    CreateExpertServicesDialogComponent,
    CreateConsultantDialogComponent,
    EditExpertServicesHyperlinkCellViewerComponent,
    EditExpertServicesStringCellViewerComponent,
    ConsultantArchiveDialogComponent,
    ExpertServiceCheckboxUpdateDialogComponent,
    MarketPlaceNavigationComponent,
    DialogDefinitionNavigationComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(expertServicesRoutes),
    SharedModule
  ]
})
export class ExpertServicesModule {
  constructor(private particleService: ParticleService,
              private commandService: CommandService,
              private platformToolExpertServicesHandler: PlatformToolExpertServicesHandler,
              private platformToolCreateConsultantHandler: PlatformToolCreateConsultantHandler,
              private createExpertWorkspaceCommandHandler: CreateExpertWorkspaceCommandHandler,
              private createExpertServiceCommandHandler: CreateExpertServiceCommandHandler,
              private createServiceTemplateCommandHandler: CreateServiceTemplateCommandHandler,
              private platformApiProvider: PlatformApiProvider) {
    ExpertServicesDynamicComponentHelper.init();
    ExpertServicesDynamicComponentHelper.register('PlatformToolExpertServicesHandler', platformToolExpertServicesHandler);
    ExpertServicesDynamicComponentHelper.register('PlatformToolCreateConsultantHandler', platformToolCreateConsultantHandler);
    ExpertServicesDynamicComponentHelper.register('CreateExpertWorkspaceCommandHandler', createExpertWorkspaceCommandHandler);
    ExpertServicesDynamicComponentHelper.register('CreateExpertServiceCommandHandler', createExpertServiceCommandHandler);
    ExpertServicesDynamicComponentHelper.register('CreateServiceTemplateCommandHandler', createServiceTemplateCommandHandler);
    this.particleService.registerCellComponent('EditExpertServicesHyperlinkCellViewerComponent',
      EditExpertServicesHyperlinkCellViewerComponent);
    this.particleService.registerCellComponent('EditExpertServicesStringCellViewerComponent', EditExpertServicesStringCellViewerComponent);
    this.platformApiProvider.registerAtTop(new ExpertServicesApiProvider());
    let command = new PlatformCommand('CreateExpertServiceWorkspaceToolLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/workspace', command);

    command = new PlatformCommand('CreateExpertServiceAnalyticToolLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/analytics', command);

    command = new PlatformCommand('CreateConsultantExpertServicesToolLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/services', command);

    /*command.fieldValues['SelectedTabId'] = 'ServiceTemplates';
    this.commandService.registrPlatformLinkCommand('/expert-services/service-provider/templates', command);*/

    command = new PlatformCommand('CreateConsultantExpertServicesToolLinkCommand', 'MarketPlaceApi');
    command.fieldValues['SelectedTabId'] = 'ActiveServices';
    this.commandService.registrPlatformLinkCommand('/expert-services/service-provider/services', command);

    command = new PlatformCommand('CreateConsultantsToolLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/service-provider/consultants', command);

    command = new PlatformCommand('OpenServiceDashboardCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/service-workspace', command);

    command = new PlatformCommand('CustomSolutionsClientViewCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/clients', command);
    command = new PlatformCommand('OpenCompaniesLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/companies', command);
    command = new PlatformCommand('OpenCompanySolutionsLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('expert-services/solutions', command);
    command = new PlatformCommand('OpenAdminAnalyticLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/admin/analytics', command);
    command = new PlatformCommand('OpenAdminUsageReportsLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/admin/usage-reports', command);
    command = new PlatformCommand('OpenConsultantAnalyticLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/consultant/analytics', command);
    command = new PlatformCommand('OpenConsultantCompaniesLinkCommand', 'MarketPlaceApi');
    command = new PlatformCommand('OpenConsultantMembersLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/consultant/members', command);
    this.commandService.registrPlatformLinkCommand('/expert-services/consultant/companies', command);
    command = new PlatformCommand('OpenConsultantSolutionsLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/consultant/solutions', command);
    command = new PlatformCommand('OpenConsultantUsageReportsLinkCommand', 'MarketPlaceApi');
    this.commandService.registrPlatformLinkCommand('/expert-services/consultant/usage-reports', command);

  }
}
